import { useState, useEffect } from "react";
import Nav from '../components/Nav/Nav';
import Footer from '../components/Footer/Footer';
import '../style/Pricing.css';
import '../App.css';
import '../style/Home.css';
import Faq from '../components/Faq'; 
import ContactModal from '../components/Modals/ContactModal';


import {  CheckCircleFilled,CreditCardOutlined, FieldTimeOutlined,RocketOutlined} from "@ant-design/icons";
import {
    CloseOutlined,
    LeftOutlined,
    RightOutlined
  } from "@ant-design/icons";

function Pricing() {
    const [isOpen, setIsOpen] = useState(false);
    const [idx, setIdx] = useState(0); // plan visible en mobile
    const heads = ["Starter", "Booster", "Expert"];

const groups = [
  {
    title: "Fonctionnalités",
    rows: [
      ["Menu digital en 10 langues",          [true,  true,  true]],
      ["Optimisation des prix avec l'IA",        [true, true,  true]],
      ["Mises à jour instantanées du menu",      [true, true, true]],
      ["Commande et paiement à table",      [false, true, true]],
      ["Optimisation du référencement local",          [false, "Un expert dédié 3h tous les 4 mois", "Un expert dédié 3h tous les 4 mois"]],
      ["Réponses personnalisées aux avis avec l'IA",        [false, false, true]],
      ["Site web personnalisé",        [false, false, true]],

    ],
  },
  {
    title: "Support et installation",
    rows: [
      ["QR code personnalisé (A7)",     ["2,50 € / QR code",  "2 € / QR code",  "1,50 € / QR code"]],
      ["Installation",     ["0 €",  "0 €",  "0 €"]],

    ],
  },
];

useEffect(() => {
  if (isOpen) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'unset';
  }

  return () => {
    document.body.style.overflow = 'unset';
  };
}, [isOpen]);

/* --------- Helpers rendu cellule --------- */
const Cell = ({ v }) =>
  v === true ? (
    <CheckCircleFilled className="icon icon--check" />
  ) : v === false ? (
    <CloseOutlined className="icon" />
  ) : (
    v /* string */
  );


  const prev = () => setIdx((i) => (i === 0 ? heads.length - 1 : i - 1));
  const next = () => setIdx((i) => (i === heads.length - 1 ? 0 : i + 1));





  return (
    <div className="one-page">
      <Nav home/>
      <div className="main">
        <div className="wrapper-page">
         
          <div className="wrapper-page-header pad-wrapper">
              <div>
                <h1 className="wrapper-page-title ">Choisissez l'offre qui vous convient</h1>
                <p className="page-subtitle">
                3 offres pour gérer votre entreprise. 1 mois d’essai gratuit sans carte bancaire et aucun frais d'installation.
                </p>
              </div>
            </div>

    <div className='pad-wrapper pad-wrapper-y'>
    <section className="pricing">
      {/* ----- Formule Starter ----- */}
      <article className="pricing-card pricing-card--starter">
        <header>
                    <p className="pricing-card__type">Starter</p>
                    <div>
          <p className="pricing-card__from">À partir de</p>
          <p className="pricing-card__price">29 €<span className='pricing-month'> / mois</span></p>
          </div>
          <p className="pricing-card__blurb">
          Conçu pour les restaurants qui souhaitent offrir un menu digital multilingue. Aucune intégration, prêt à servir vos clients du monde entier.

          </p>
          <button className="main-button"  onClick={()=> setIsOpen(true)}>Essayez gratuitement</button>

        </header>

        <hr className="pricing-card__divider" />

        <h4 className="pricing-card__incl">Inclus :</h4>
        <ul className="pricing-card__list">
          <li><CheckCircleFilled className="pricing-check" />Menu digital en 10 langues</li>
          <li><CheckCircleFilled className="pricing-check" />Optimisation des prix avec l'IA</li>
          <li><CheckCircleFilled className="pricing-check" />Mises à jour instantanées du menu</li>
        </ul>
      </article>


      {/* ----- Formule Premium ----- */}
      <article className="pricing-card pricing-card--premium pricing-card--highlight">
        <header>
            <div className='pricing-container'>
            <p className="pricing-card__type">Booster</p>
            <div className='pricing-card__cta'>Recommandé</div>

            </div>
             <div>
          <p className="pricing-card__from">À partir de</p>
          <p className="pricing-card__price">69 €<span className='pricing-month'> / mois</span></p>
          </div>
          <p className="pricing-card__blurb">
            Offrez un menu multilingue et gagnez en visibilité, le référencement local optimisé place votre restaurant en tête des recherches.

          </p>
          <button className="main-button"  onClick={()=> setIsOpen(true)}>Essayez gratuitement</button>
        </header>

        <hr className="pricing-card__divider" />
       

        <h4 className="pricing-card__incl">Inclus :</h4>
        <ul className="pricing-card__list">
          <li><CheckCircleFilled className="pricing-check" />Tout le pack Starter</li>
          <li><CheckCircleFilled className="pricing-check" />Optimisation du référencement local</li>
          <li><CheckCircleFilled className="pricing-check" />Commande et paiement à table</li>
        </ul>
      </article>

      <article className="pricing-card pricing-card--premium">
        <header>
        <p className="pricing-card__type">Expert</p>
          <div>
          <p className="pricing-card__from">À partir de</p>
          <p className="pricing-card__price">99 €<span className='pricing-month'> / mois</span></p>
          </div>
          <p className="pricing-card__blurb">
          Le choix idéal pour les restaurants qui cherchent à doper leurs revenus et fluidifier leurs opérations grâce à la suite Fastline tout-en-un.

          </p>
          <button className="main-button"  onClick={()=> setIsOpen(true)}>Essayez gratuitement</button>
        </header>

        <hr className="pricing-card__divider" />

        <h4 className="pricing-card__incl">Inclus :</h4>
        <ul className="pricing-card__list">
          <li><CheckCircleFilled className="pricing-check" />Tout le pack Booster</li>
          <li><CheckCircleFilled className="pricing-check" />Réponses personnalisées aux avis avec l'IA</li>
          <li><CheckCircleFilled className="pricing-check" />Site web personnalisé</li>
        </ul>
      </article>
    </section>
   </div>
   {isOpen && <ContactModal pricing setIsOpen={() => setIsOpen(false)}/>}


   <div className='advantages-wrapper white-bg'>
            <div className='advantages-title '>
            <h2>Tout est dans les détails</h2>
            </div>
            <div  className='advantages-bloc services-block pad-price-title'> 
        <div className="matrix-desktop">
        <table className="matrix-table">
          <thead>
            <tr>
              <th></th>
              {heads.map((h) => (
                <th key={h}>{h}</th>
              ))}
            </tr>
          </thead>

          {groups.map(({ title, rows }) => (
            <tbody key={title}>
              <tr className="cat">
                <td colSpan={heads.length + 1}>{title}</td>
              </tr>

              {rows.map(([label, vals]) => (
                <tr key={label}>
                  <td className="label">{label}</td>
                  {vals.map((v, i) => (
                    <td key={i}>
                      <Cell v={v} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          ))}
        </table>
      </div>

      {/* ===== Mobile ===== */}
      <div className="matrix-mobile">
        <header className="mobile-head">
          <button className="arrowz" onClick={prev} aria-label="Précédent">
            <LeftOutlined />
          </button>
          <h2>{heads[idx]}</h2>
          <button className="arrowz" onClick={next} aria-label="Suivant">
            <RightOutlined />
          </button>
        </header>

        {groups.map(({ title, rows }) => (
          <section key={title} className="mobile-group">
            <h3>{title}</h3>
            {rows.map(([label, vals]) => (
              <div key={label} className="mobile-row">
                <span className="mobile-label">{label}</span>
                <span className="mobile-val">
                  <Cell v={vals[idx]} />
                </span>
              </div>
            ))}
          </section>
        ))}
      </div>


          </div>
          </div>

          <div className='advantages-wrapper '>
            <div className='advantages-title'>
            <h2>Notre promesse</h2>
            </div>
            <div  className='advantages-bloc services-block'> 
     
  
 <section className="steps">
      {/* -------- 1 -------- */}

      {/* -------- 2 -------- */}
      <article className="step">
        <CreditCardOutlined className="step__icon" />
        <h3 className="step__title">
        Sans Carte Bancaire
        </h3>
        <p className="step__text">
        Essayez la plateforme gratuitement, sans entrer de carte bancaire.
Explorez toutes les fonctionnalités l’esprit tranquille.

        </p>
      </article>

      {/* -------- 3 -------- */}
      <article className="step">
        <FieldTimeOutlined className="step__icon" />
        <h3 className="step__title">
        1 mois d’essai gratuit
</h3>
        <p className="step__text">
        Un mois complet pour découvrir librement nos fonctionnalités.
Si vous êtes conquis, poursuivez ; sinon, vous partez sans frais ni engagement.

        </p>
      </article>

      <article className="step">
        <RocketOutlined className="step__icon" />
        <h3 className="step__title">
        Installation en 7 jours
</h3>
        <p className="step__text">
        Mise en place complète sous 7 jours, de la configuration à la mise en ligne.
Vous êtes prêt à accueillir vos client sen une semaine.

        </p>
      </article>
    </section>

          </div>
          </div>
   

          <div className='advantages-wrapper grey-bg pb-qna'>
            <div className='advantages-title center-bg'>
            <h2>Questions fréquentes</h2>
            </div>
            <div  className='advantages-bloc services-block '> 
          <Faq></Faq>
            </div>
            </div>
          
        </div>
      </div>
     <Footer />
    </div>
  )
}

export default Pricing